import { createFileRoute } from "@tanstack/react-router";
import TalkingToYourPsychiatrist from "@/pages/TalkingToYourPsychiatrist";
export const Route = createFileRoute("/talking-to-your-psychiatrist")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Talking To Your Psychiatrist | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "How to talk to your psychiatrist about TMS, SAINT TMS, and treatment-resistant depression. A guide for your next appointment in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Talking To Your Psychiatrist | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "How to talk to your psychiatrist about TMS, SAINT TMS, and treatment-resistant depression. A guide for your next appointment in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/talking-to-your-psychiatrist",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/talking-to-your-psychiatrist",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TalkingToYourPsychiatrist />;
}
